// Coordinates playback across every video/iframe embed on the page so
// starting one automatically pauses whatever else was playing (e.g. the
// Reviews page video carousel) — matches the familiar "only one video plays
// at a time" behavior guests expect.

interface Player {
  pause: () => void;
}

const players = new Set<Player>();

export function registerPlayer(player: Player): () => void {
  players.add(player);
  return () => players.delete(player);
}

export function notifyPlaying(player: Player) {
  players.forEach((p) => {
    if (p !== player) p.pause();
  });
}
